module.exports = __webpack_public_path__ + "static/media/file-import.7d4a1605.svg";